import Vue from 'vue'
import Vuex from 'vuex'
import AppStore from '@/store/AppStore.js'
import UserStore from '@/store/UserStore.js'
import OrganisationStore from '@/store/OrganisationStore.js'
import FacilityStore from '@/store/FacilityStore.js'
import PractitionerStore from '@/store/PractitionerStore.js'
import TestStore from '@/store/TestStore.js'
import NotificationStore from '@/store/NotificationStore.js'
import SearchStore from '@/store/SearchStore.js'
import LanguageStore from '@/store/LanguageStore.js'
import SignalRStore from '@/store/SignalRStore.js'
import EthnicityStore from '@/store/EthnicityStore.js'
import AddressFormStore from '../../../Common/store/AddressFormStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { 
    AppStore,
    UserStore,
    OrganisationStore,
    FacilityStore,
    PractitionerStore,
    TestStore,
    NotificationStore,
    SearchStore,
    LanguageStore,
    SignalRStore,
    EthnicityStore,
    AddressFormStore
  }
})